<template>
  <div class="row">
    <div v-for="stat in estadisticas" :key="stat.clave" class="col-md-6 col-xl-3 mb-4">
      <div class="card stat-card h-100" :style="{ '--stat-color': stat.color }">
        <div class="card-body">
          <div class="d-flex stat-encabezado">
            <div class="flex-grow-1 stat-texto">
              <p class="stat-label">{{ stat.titulo }}<i class="fa fa-circle"></i></p>
              <h4 class="stat-valor">{{ formatear(stat.valor) }}</h4>
            </div>
            <div class="stat-icono">
              <i :class="stat.icono"></i>
            </div>
          </div>
          <div class="stat-linea" aria-hidden="true">
            <span class="stat-pulso"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-xl-6 mb-4">
      <div class="card accesos-card h-100">
        <div class="card-body d-flex flex-wrap align-items-center justify-content-center gap-3">
          <router-link to="/dashboard/banco-imagenes" class="acceso-btn acceso-btn-primario">
            <vue-feather type="image" size="18" />
            <span>Banco de imágenes</span>
          </router-link>
          <router-link to="/dashboard/cargar-imagenes" class="acceso-btn acceso-btn-suave">
            <vue-feather type="upload" size="18" />
            <span>Subir imagen</span>
          </router-link>
          <router-link to="/dashboard/cargar-productos-gs1/individual" class="acceso-btn acceso-btn-suave">
            <vue-feather type="upload" size="18" />
            <span>Subir imagen GS1</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResumenCards",
  props: {
    totalProductos: { type: Number, default: 0 },
    imagenesUltimos7Dias: { type: Number, default: 0 },
  },
  computed: {
    estadisticas() {
      return [
        {
          clave: "total",
          titulo: "Total de imágenes",
          icono: "fas fa-images",
          color: "#f5b72f",
          valor: this.totalProductos,
        },
        {
          clave: "semana",
          titulo: "Últimos 7 días",
          icono: "fas fa-calendar-week",
          color: "#48a3d7",
          valor: this.imagenesUltimos7Dias,
        },
      ];
    },
  },
  methods: {
    formatear(n) {
      return Number(n || 0).toLocaleString();
    },
  },
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}
.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}
.card-header {
  background-color: #f8f9fa;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
}
/* Accesos rápidos */
.accesos-card {
  --acceso-color: var(--theme-deafult, #5c61f2);
  border-radius: 16px;
}
.accesos-card .card-body {
  padding: 16px 20px;
}
.acceso-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s, transform 0.2s;
}
.acceso-btn:hover {
  transform: translateY(-2px);
}
.acceso-btn-primario {
  background-color: var(--acceso-color);
  color: #ffffff;
}
.acceso-btn-primario:hover {
  color: #ffffff;
  box-shadow: 0 6px 16px color-mix(in srgb, var(--acceso-color) 35%, transparent);
}
.acceso-btn-suave {
  background-color: color-mix(in srgb, var(--acceso-color) 8%, #ffffff);
  color: #2c323f;
}
.acceso-btn-suave:hover {
  background-color: var(--acceso-color);
  color: #ffffff;
}

/* Tarjetas de estadísticas (estilo "Products/Messages" del tema) */
.stat-card {
  --stat-color: var(--theme-deafult, #5c61f2);
  border-radius: 20px;
}
.stat-card:hover {
  transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.stat-card .card-body {
  padding: 26px 30px 28px;
}
.stat-encabezado {
  align-items: flex-start;
  gap: 16px;
}
.stat-texto {
  min-width: 0;
}
.stat-label {
  width: fit-content;
  margin-bottom: 14px;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: var(--stat-color);
  background-image: linear-gradient(to right, transparent, color-mix(in srgb, var(--stat-color) 12%, transparent) 30%);
}
.stat-label i {
  font-size: 3px;
  margin-left: 8px;
  vertical-align: middle;
}
.stat-valor {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 0;
  color: #2c323f;
}
.stat-icono {
  flex-shrink: 0;
  font-size: 34px;
  line-height: 1;
  color: var(--stat-color);
}
.stat-linea {
  position: relative;
  width: 45%;
  height: 3px;
  margin-top: 26px;
  border-radius: 10px;
  background-image: linear-gradient(to right, transparent, var(--stat-color));
}
.stat-linea::after {
  position: absolute;
  content: "";
  top: -3px;
  right: -4px;
  width: 9px;
  height: 9px;
  border-radius: 100%;
  background-color: var(--stat-color);
  box-shadow: 0 0 12px 3px color-mix(in srgb, var(--stat-color) 36%, transparent);
}
.stat-pulso {
  position: absolute;
  top: -11px;
  right: -12px;
  width: 25px;
  height: 25px;
  border: 5px solid var(--stat-color);
  border-radius: 70px;
  animation: heartbit 1s ease-out infinite;
}
@keyframes heartbit {
  0% { transform: scale(0); opacity: 0; }
  25% { transform: scale(0.1); opacity: 0.1; }
  50% { transform: scale(0.5); opacity: 0.3; }
  75% { transform: scale(0.8); opacity: 0.5; }
  100% { transform: scale(1); opacity: 0; }
}
</style>
